<template>
    <div>
        <Table border :loading="loading" :columns="columns" :data="data" style="margin:20px 0">
            <template slot-scope="{ row, index }" slot="action">
                <Button type="primary" icon="md-reorder" size="small" @click="teamInfo(row, index)"></Button>
            </template>
            
        </Table>
        <div style="display:flex;justify-content: flex-end;">
            
        </div>
        <div style="display: flex;justify-content: space-between;margin: 30px 0;">
            <!-- <Page :total="total" @on-change="pageChange"></Page> -->
            <Button type="primary" style="margin-top:15px" @click="returnPage" v-if="showreturnbtn"><!-- 返回 -->{{$t('Return')}}</Button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    
    data(){
        return{
            showreturnbtn:false,
            loading:false,
            
            data:[],
            modalShow:false,
            modal:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 100,
            },
            total: 0,
            id:''
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: "NO",
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: this.$t('Meeting_Members'),/* 参会者 */
                    key: "userName",
                    align: "center",
                    minWidth:120
                },{
                    title: this.$t('English_Name'),/* 任职者 */
                    key: "userEName",
                    align: "center",
                    minWidth:120
                },{
                    title: this.$t('Team'),/* 查看团队信息 */
                    slot: "action",
                    align: "center",
                    minWidth:120
                }
            ]
        }
    },
    created(){},
    mounted(){
    },
    methods:{
        getData(){
            let obj={
                id:this.id,
                ...this.pageInfo
            }
            this.loading=true
            axios.post("/TalentInventory/selectParticipants", obj).then((res) => {
                this.loading=false
                if(res){
                    this.data=res.data
                    this.total = parseInt(res.pageInfo.total)
                }
            })
        },
        teamInfo(row,index){
            // window.open(window.location. origin + #/evalReport?id=${this.$route.query.id}&orgId=${this.highTechForm.orgId})
            // const href = this.$router.resolve({path:"/090E24C0B112F54BB8C0D94347DD0212/A3FFBEBFDB713E27",query: { pageLink: 'name1' ,plan:true,id:row.talentInventoryId,serialnumber:row.serialnumber}});
            const href="/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27/?pageLink=name1&plan=true&id="+row.talentInventoryId+"&serialnumber="+row.serialnumber+'&pagename='+row.userName + "&beEnd=" + this.$route.query.beEnd
            window.open(href,'_blank');
            // this.$router.push({ path: '/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27', 
            // query: { pageLink: 'name1' ,plan:true,id:row.talentInventoryId,serialnumber:row.serialnumber} })
        },
        inventory(row,index){
            this.$router.push({ path: '/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27', query: { 
                pageLink: 'name2',plan:true ,id:row.talentInventoryId,serialnumber:row.serialnumber,beTopLevel:row.beTopLevel} })
        },
        personPage(){
            const href = this.$router.resolve({path:"/090E24C0B112F54BB8C0D94347DD0212/A3FFBEBFDB713E27",query:{id:1}});
            window.open('/090E24C0B112F54BB8C0D94347DD0212/A3FFBEBFDB713E27','_blank');
        },
        deleteItem(){},
        selectUser(){
            this.$refs.selectPeopleVue.modal=true
        },
        returnPage(){
            this.$router.back()
        },
        pageChange(val){
            this.pageInfo.pageNo = val;
            this.getData()
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/process/performanceManagement/PeopleBoardComponents/TeamOverview.vue